class CardSlider {
	constructor() {
		this.setupSlider();
	}

	setupSlider() {
		// eslint-disable-next-line no-undef
		new Swiper('.card-slider', {
			slidesPerView: 1.075,
			spaceBetween: 20,
			loop: false,
			navigation: {
				prevEl: '.card-slider__prev',
				nextEl: '.card-slider__next',
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
			on: {
				init: this.handleInit.bind(this),
				resize: this.handleSlideResize.bind(this),
				slideChange: this.handleSlideChangeStart.bind(this),
			},
		});
	}

	handleInit(swiper) {
		if ('undefined' !== typeof swiper.$el[0]) {
			// this.setMaxSlideCount(swiper);
			this.setProgressLineSize(swiper);
		}
	}

	getMaxSlideCount(swiper) {
		const slidesPerView = swiper.currentBreakpoint === 'max' ? 1 : 3;
		return swiper.slides.length + 1 - slidesPerView;
	}

	handleSlideResize(swiper) {
		if ('undefined' !== typeof swiper.$el[0]) {
			// this.setMaxSlideCount(swiper);
			this.setProgressLineSize(swiper);
		}
	}

	handleSlideChangeStart(swiper) {
		// Set current slide num.
		// const currentSlideNum = swiper.$el[0].querySelector('.card-slider__current-slide-num');
		// currentSlideNum.innerHTML = swiper.realIndex + 1;

		// Set progress line width.
		this.setProgressLineSize(swiper);
	}

	setMaxSlideCount(swiper) {
		const maxSlideNumEl = swiper.$el[0].querySelector('.card-slider__max-slide-num');
		const maxSlideNum = this.getMaxSlideCount(swiper);
		maxSlideNumEl.innerHTML = maxSlideNum;
	}

	setProgressLineSize(swiper) {
		const maxSlideNum = this.getMaxSlideCount(swiper);
		const progressLine = swiper.$el[0].querySelector('.card-slider__progress-line');
		const lineWidth = (100 / maxSlideNum) * (swiper.realIndex + 1);
		progressLine.style.width = `${parseFloat(lineWidth.toFixed(4))}%`;
	}
}

new CardSlider();
